/**
 * FRD 2.11 N/A visual helpers.
 *
 * N/A is a flag, never a compliance answer. Control is always switch + N/A
 * on the right.
 */
export function shouldShowAnsweredSummary(
  isNotApplicable: boolean,
  totalItems: number
): boolean {
  return !isNotApplicable && totalItems > 0;
}

export function isChecklistItemFullyNotApplicable(
  answerIds: readonly string[],
  isAnswerApplicable: (answerId: string) => boolean
): boolean {
  if (answerIds.length === 0) {
    return false;
  }

  return answerIds.every((answerId) => !isAnswerApplicable(answerId));
}
